import { useContext } from "react"

// Navigation
import { Routes } from "@/constants/routes"
import { useLocation, matchPath } from "@/lib/router"

// Context
import { AuthLayoutContext } from "@/layouts/AuthLayout"
import { UserRoles } from "@/constants/constants"
import { useCurrentUserRoles } from "@/context/user"

// UI
import { cn } from "@/lib/utils"
import { Link } from "@/components/Anchor"
import { NavItem } from "@/components/navigation/NavItem"

// Icons
import { ChartBarIcon } from "@/lib/icons"

// Translation
import { useTrans } from "@/i18n"

// Environment variables
import { EXTERNAL_PLATFORM_ZONHUB_STATS_COMPANY } from "@/lib/env"

/**
 * StatsSubMenu
 * @returns
 */
export function StatsSubMenu() {
	// Router
	const location = useLocation()

	// Translation
	const t = useTrans(["common", "project"])

	// Context
	const { setMobileMenuOpen } = useContext(AuthLayoutContext)
	const { hasOneOfRoles } = useCurrentUserRoles()

	// Functions
	function closeMenu() {
		setMobileMenuOpen(false)
	}

	function isPlatformStatsSpecificSubPath() {
		// Return true if it is a full match
		if (location.pathname === Routes.StatisticsPlatform) {
			return true
		}

		// Check if the current path is a subpath of the Platform stats
		const matchesPath = matchPath(
			{
				path: Routes.StatisticsPlatform,
				end: false,
			},
			location.pathname,
		)
		return matchesPath !== null
	}

	return (
		<NavItem
			name={t("common:common.navigation.statistics.title")}
			datda-testid="common.nav.dashboard"
			icon={ChartBarIcon}
		>
			<nav className="space-y-1 pr-3">
				<Link
					className={cn(
						isPlatformStatsSpecificSubPath() &&
							"active-navigation-item",
						"block truncate text-sm hover:text-gray-500",
					)}
					href={Routes.StatisticsPlatform}
					onClick={closeMenu}
				>
					{t("common:common.navigation.statistics.platform.link")}
				</Link>
				<Link
					className={cn(
						location.pathname === Routes.StatisticsImpact &&
							"active-navigation-item",
						"block truncate text-sm hover:text-gray-500",
					)}
					href={Routes.StatisticsImpact}
					onClick={closeMenu}
				>
					{t("common:common.navigation.statistics.impact.link")}
				</Link>

				{/** Company stats */}
				{hasOneOfRoles(UserRoles.admin) && (
					<Link
						className={cn(
							"block truncate text-sm hover:text-gray-500",
						)}
						href={EXTERNAL_PLATFORM_ZONHUB_STATS_COMPANY}
						onClick={closeMenu}
					>
						Company
					</Link>
				)}
			</nav>
		</NavItem>
	)
}
